module.exports = __webpack_public_path__ + "static/media/21_negro.e070c83f.svg";